import { createStore } from "vuex";
import auth from "./modules/auth";
import event from "./modules/event";
import category from "./modules/category";
import organizer from "./modules/organizer";
import dashboard from "./modules/dashboard";
import user from "./modules/user";

export default createStore({
	modules: {
		auth,
		event,
		category,
		organizer,
		dashboard,
		user,
	},
});
